export function formatPrice (price) {
  return price
    ? (+price)?.toLocaleString('ru-RU', {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      useGrouping: true
    })
    : price
}

export function formatVolume (volume) {
  return volume
    ? (+volume)?.toLocaleString('ru-RU', {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      useGrouping: false
    })
    : volume
}

export function formatPercent (val, order = 100) {
  const value = Math.round((Math.round(val * order) / order) || 0)
  return value
}
